require('./RAObjectiveTrackingView.scss');
require('./RAObjectiveTrackingView.override.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const ReactDOM = require('react-dom');
const { withRouter } = require('react-router-dom');
const moment = require('moment');
const Immutable = require('immutable');

// @commons
const RACover = require('../../components/commons/RACover/RACover');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const OKModal = require('components/commons/OKModal/OKModal');
const RAInformativeBox = require('../../components/commons/RAInformativeBox/RAInformativeBox');
const RAGoalNotification = require('../../components/RAGoalNotification/RAGoalNotification');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const { OKMessage } = require('commonsComponents/OKMessage');

// @constants
const { BROKER_PG_URL, EURO_TEXT, LOADING } = require('constants/index');
const { MODIFY_SUITABILITY_TEST } = require('constants/flagBasedFeatures');
const {
    GOAL_DISTRIBUTION_URL,
    MINIMUM_STRATEGY_BALANCE_REIMBURSEMENT,
    MYPROFILE_BROKER_ROBO_URL,
    RA_LAST_MOVEMENTS_URL,
    OBJECTIVE_TRACK_URL_PARA,
    RA_CANCEL_PLAN_URL,
    RA_MODIFY_PLAN_URL,
    RA_MANAGEMENT_CONTRIBUTION_URL,
    RA_REIMBURSEMENT_URL,
    SUITABILITY_TEST_STATUS_URL,
    RA_ADDITIONAL_CONTRIBUTION_URL,
    SUITABILITY_TEST_HIGH_CONSERVATIVE,
    RA_SUITABILITY_TEST_MODIFYGOAL_OPERATION,
    RA_SUITABILITY_TEST_URL,
    RA_ACCOUNT_DETAILS_URL,
    RA_COVER_FONT,
    RA_DISSOCIATE_OBJECTIVE_URL,
    GOAL_TRACKING_URL,
    RA_FUND_TRANSFER_STEP1,
    RA_FUND_TRANSFER_STEP2,
    RA_FUND_TRANSFER_STEP3,
    RA_PORTFOLIO_FUND_HIRING_METHOD,
    PROC_RA_OBJECTIVE_TRACKING_INTERACTION,
    PROC_RA_MODIFY_WALLET_NAME,
    PROC_RA_GO_BACK,
    PROC_RA_HELP_PATRIMONY_CALCULATION,
    PROC_RA_OBJECTIVE_TRACKING_EVOLUTION_CHART_HELP,
    PROC_RA_MANAGE_CONTRIBUTIONS,
    PROC_RA_NEW_CONTRIBUTION,
    PROC_RA_OBJECTIVE_TRACKING_MONEY_MARKET_HELP,
    PROC_RA_OBJECTIVE_TRACKING_DISTRIBUTION,
    PROC_RA_GO_TO_ORDERS_AND_MOVEMENTS,
    PROC_RA_OBJECTIVE_TRACKING_PARTIAL_REFUND,
    PROC_RA_OPTIONS_MENU,
    PROC_RA_TRACKING_ORDERS_MOVEMENTS,
    PROC_RA_OBJECTIVE_TRACKING_MODIFY_STRATEGY,
    PROC_RA_TRACKING_SUITABILITY_TEST,
    PROC_RA_OBJECTIVE_TRACKING_TOTAL_REFUND,
    PROC_RA_OBJECTIVE_TRACKING_ACCOUNT_DETAILS,
    PROC_RA_OBJECTIVE_TRACKING_DISSOCIATE_OBJECTIVE,
    PROC_RA_OBJECTIVE_TRACKING_MANAGE_CONTRIBUTIONS,
    PROC_RA_GLOBAL_POSITION_RETURN_TEST,
} = require('../../raConstants/index');

// @utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const ScrollUtils = require('utilities/scrollUtils');
const {
    getCountAndUnitTerms,
} = require('../../utilities/RAObjectiveTrackingGetYearAndNoOfPoints');
const {
    isTestExpired,
    isTestValid,
} = require('../../utilities/RASuitabilityTestHelper');
const {
    recordLink,
    PROC_RA_GLOBAL_POSITION_INTERACTION,
} = require('utilities/tagging');

// @components
const RAAlertsWidget = require('../../components/RAAlertsWidget/RAAlertsWidget');
const RAContributions = require('../../components/RAObjectiveTracking/RAContributions/RAContributions');
const RAPortfolioEvolution = require('../../components/RAPortfolioEvolution/RAPortfolioEvolution');
const RAExpectedProfitability = require('../../components/RAExpectedProfitability/RAExpectedProfitability');
const RADistributionWidget = require('../../components/RADistributionWidget/RADistributionWidget');
const RAObjectiveDetails = require('../../components/RAObjectiveDetails/RAObjectiveDetails');
const RAAccordionDistributionTable = require('../../components/RAAccordionDistributionTable/RAAccordionDistributionTable');
const RARoboMoreOptionsButton = require('../../components/RARoboMoreOptionsButton/RARoboMoreOptionsButton');
const RAFeatureFlagModal = require('../../components/RAFeatureFlagModal/RAFeatureFlagModal');
const RAModifyPlanWarningModal = require('../../components/RAModifyPlanWarningModal/RAModifyPlanWarningModal');
const RACgdNumber = require('../../components/RACgdNumber/RACgdNumber');
const RAFundTransferNotification = require('../../components/RAFundTransferNotification/RAFundTransferNotification');
const RATestExpirationDisclaimer = require('../../components/RATestExpirationDisclaimer/RATestExpirationDisclaimer');

// @actions
const brokerMyInvestments = require('actions/brokerMyInvestments');
const raEvolutionChartOjectiveTracking = require('../../actions/RAEvolutionChartOjectiveTracking');
const raProjectionChartOjectiveTracking = require('../../actions/RAProjectionChartOjectiveTracking');
const raObjectiveDetailsActions = require('../../actions/RAObjectiveDetails');
const raAccountDetailsActions = require('../../actions/RAAccountDetails');
const raPortfoliosNameHistoryActions = require('../../actions/RAPortfoliosNameHistory');
const RAAlertsActions = require('../../actions/RAAlerts');
const RAFeatureFlagActions = require('../../actions/RAFeatureFlag');
const raLastMovementActions = require('../../actions/RALastMovement');
const raGlobalPosition = require('../../actions/RAGlobalPosition');
const suitabilityActions = require('../../actions/RASuitabilityTest');

const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const RAObjectiveInfomationNotification = require('../../components/contactCenter/RAObjectiveInfomationNotification/RAObjectiveInfomationNotification');
class RAObjectiveTrackingView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isModifyModalOpen: false,
            isPartialRefundModalOpen: false,
            moneyMarketModalIsOpen: false,
            showGoalNotification: true,
            showGoalNotificationForContactCenter: true,
            showFundTrasnferNotification: true,
            showModalTestExpired: false, /// ver cond donde se activa
            showUnsuitableTestCancelation: true,
        };
        this.handleEmptyEvolutionLinkClick = this.handleEmptyEvolutionLinkClick.bind(
            this,
        );
        this.handleAdditionalContribution = this.handleAdditionalContribution.bind(
            this,
        );
        this.handleFeatureModal = this.handleFeatureModal.bind(this);
        this.handleGoalNotificationAmountClick = this.handleGoalNotificationAmountClick.bind(
            this,
        );
        this.handleModifyModalClick = this.handleModifyModalClick.bind(this);
        this.handleModifyModalClose = this.handleModifyModalClose.bind(this);
        this.handleOnProbabilityAnchorClick = this.handleOnProbabilityAnchorClick.bind(
            this,
        );
        this.handleOnUpdateCoverTitle = this.handleOnUpdateCoverTitle.bind(
            this,
        );
        this.handleModalClose = this.handleModalClose.bind(this);
        this.handleGoalNotificationClose = this.handleGoalNotificationClose.bind(
            this,
        );
        this.handleModifyGoalAmountClick = this.handleModifyGoalAmountClick.bind(
            this,
        );
        this.handleFundNotificationClose = this.handleFundNotificationClose.bind(
            this,
        );
        this.handleGoalNotificationCloseForContactCenter = this.handleGoalNotificationCloseForContactCenter.bind(
            this,
        );
        this.handlePartialRefundModalToggle = this.handlePartialRefundModalToggle.bind(
            this,
        );
        this.handleCloseModalTestExpired = this.handleCloseModalTestExpired.bind(
            this,
        );
        this.handleModalTestExpiredLink = this.handleModalTestExpiredLink.bind(
            this,
        );
        this.handleCloseUnsuitableTest = this.handleCloseUnsuitableTest.bind(
            this,
        );
        this.handleReturnTestClick = this.handleReturnTestClick.bind(this);
    }

    componentDidMount() {
        const {
            removeFilter,
            setOriginRedirection,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        this.init();
        removeFilter();
        setOriginRedirection(OBJECTIVE_TRACK_URL_PARA, portfolioId);
    }

    componentDidUpdate(prevProps) {
        const {
            immGlobalPosition,
            immObjectiveDetailsReducer,
            requestPortfolioEvolutionChart,
            requestProjectionChart,
            setDaysDiffrence,
            match: {
                params: { portfolioId },
            },
        } = this.props;

        const immPrevObjectiveDetailsReducer =
            prevProps.immObjectiveDetailsReducer;
        const objectiveDetailSuccess = immObjectiveDetailsReducer.get(
            'isSuccess',
        );
        const prevObjectiveDetailSuccess = immPrevObjectiveDetailsReducer.get(
            'isSuccess',
        );
        const prevPortfolioId = prevProps.match.params.portfolioId;

        if (
            objectiveDetailSuccess !== prevObjectiveDetailSuccess ||
            portfolioId !== prevPortfolioId
        ) {
            const nextGoalDate = immGlobalPosition.getIn([
                'portfolios',
                portfolioId,
                'goalInformation',
                'goalDate',
            ]);
            const portfolioStartDate = immGlobalPosition.getIn([
                'portfolios',
                portfolioId,
                'created',
            ]);
            setDaysDiffrence(nextGoalDate);
            requestProjectionChart(portfolioId);
            requestPortfolioEvolutionChart(portfolioId, portfolioStartDate);

            if (
                objectiveDetailSuccess &&
                immObjectiveDetailsReducer.get('fromGoalPGNotification')
            ) {
                const amount = immObjectiveDetailsReducer.getIn([
                    'editAmountModal',
                    'objectiveAmount',
                ]);
                this.props.showEditObjectiveAmountModal(amount);
            }
        }

        if (portfolioId !== prevPortfolioId) {
            this.init();
        }
    }

    componentWillUnmount() {
        this.props.reset();
    }

    init() {
        const {
            fetchMyInvestments,
            readPortfolioFromGlobalPosition,
            immBrokerMyInvestments,
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
            fetchFeatureFlag,
            getDisplayNames,
            getCGDAccountNumberVal,
        } = this.props;

        fetchFeatureFlag();
        getDisplayNames();
        getCGDAccountNumberVal(portfolioId);

        if (
            (immBrokerMyInvestments.get('isOutdated') &&
                !immBrokerMyInvestments.get('isFetching')) ||
            !immGlobalPosition.get('hasRoboHired')
        ) {
            fetchMyInvestments().then(() => {
                readPortfolioFromGlobalPosition(portfolioId);
            });
        } else {
            readPortfolioFromGlobalPosition(portfolioId);
        }
    }

    handleModalClose() {
        this.setState({
            moneyMarketModalIsOpen: false,
        });
    }

    handleModifyModalClick() {
        this.setState({
            isModifyModalOpen: true,
        });
    }

    handleModifyModalClose() {
        this.setState({
            isModifyModalOpen: false,
        });
    }

    handleGoalNotificationClose() {
        this.setState({
            showGoalNotification: false,
        });
    }

    handleGoalNotificationAmountClick() {
        const objectiveAmount = this.props.immObjectiveDetailsReducer.getIn([
            'editAmountModal',
            'objectiveAmount',
        ]);
        this.props.showEditObjectiveAmountModal(objectiveAmount);
    }

    openMoneyMarketModal() {
        this.setState({
            moneyMarketModalIsOpen: true,
        });
    }

    handleEmptyEvolutionLinkClick() {
        recordLink(
            PROC_RA_OBJECTIVE_TRACKING_INTERACTION,
            PROC_RA_OBJECTIVE_TRACKING_EVOLUTION_CHART_HELP,
        );
    }

    getPortfolioEvolution(immPortfolio) {
        const {
            immEvolutionChartData,
            immObjectiveDetailsReducer,
        } = this.props;
        const evolutionChartData = immEvolutionChartData.get('data').toJS();
        const objAmount = immObjectiveDetailsReducer.getIn([
            'editAmountModal',
            'objectiveAmount',
        ]);
        const chartDataFetching = immEvolutionChartData.get('isFetching');
        const isFetchingDetail = immObjectiveDetailsReducer.get(
            'isFetchingDetail',
        );
        const goalProgress = immPortfolio.getIn([
            'goalInformation',
            'goalProgress',
        ]);

        return (
            <section className="ra-objective-tracking-view__evolution-section">
                <RAPortfolioEvolution
                    data={evolutionChartData}
                    description={formatText(
                        'raObjectiveTracking-evolutionParagraph',
                    )}
                    error={!!immEvolutionChartData.get('error')}
                    goalProgress={goalProgress}
                    isObjectiveTracking={true}
                    loading={chartDataFetching || isFetchingDetail}
                    objAmount={objAmount}
                    selectedOption={EURO_TEXT}
                    title={formatText('raObjectiveTracking-evolutionTitle')}
                    onEmptyEvolutionLinkClick={
                        this.handleEmptyEvolutionLinkClick
                    }
                />
            </section>
        );
    }

    getExpectedProfitability() {
        const {
            immProjectionChartData,
            immObjectiveDetailsReducer,
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        const chartData = immProjectionChartData.get('chartData').toJS();
        const chartDataFetching = immProjectionChartData.get('isFetching');
        const daysDiff = immProjectionChartData.get('daysDiff');
        const noOfChartPoints = immProjectionChartData.get('noOfChartPoints');
        const tickInfo = getCountAndUnitTerms(daysDiff, noOfChartPoints);
        const objectiveAmount = immObjectiveDetailsReducer.getIn([
            'editAmountModal',
            'objectiveAmount',
        ]);
        const actualAmount = immObjectiveDetailsReducer.getIn([
            'keyFigures',
            'valuation',
        ]);
        const probability = immObjectiveDetailsReducer.get('probability');
        const isFetchingDetail = immObjectiveDetailsReducer.get(
            'isFetchingDetail',
        );
        const immPortfolio = immGlobalPosition.getIn(
            ['portfolios', portfolioId],
            Immutable.Map(),
        );
        const goalReached =
            immPortfolio.getIn(['goalInformation', 'goalProgress']) >= 1;
        const goalEndDate = immObjectiveDetailsReducer.get('objectiveEndDate');
        const outOfDate =
            !goalReached && moment(goalEndDate).isSameOrBefore(moment(), 'day');
        let content;
        if (!goalReached && !outOfDate) {
            content = (
                <div className="ra-objective-tracking-view__projection-question-section">
                    <h4 className="ra-objective-tracking-view__projection-question-title">
                        <FormattedText value="raObjectiveTracking-projectionQuestionTitle" />
                    </h4>
                    <FormattedText
                        className="ra-objective-tracking-view__projection-question-para"
                        value="raObjectiveTracking-projectionQuestionParagraph"
                    />
                </div>
            );
        }

        return (
            <section className="ra-objective-tracking-view__projection-section">
                <RAExpectedProfitability
                    actualAmount={actualAmount}
                    chartData={chartData}
                    error={!!immProjectionChartData.get('error')}
                    headerMarginBottom={true}
                    isObjectiveTracking={true}
                    loading={chartDataFetching || isFetchingDetail}
                    objAmount={objectiveAmount}
                    probability={probability}
                    ref={componentInstance => {
                        this.raExpectedProfitabilityComponent = componentInstance;
                    }}
                    showFooter={false}
                    subtitle={formatText(
                        'raObjectiveTracking-projectionProbabilityLabel',
                    )}
                    tickInfo={tickInfo}
                    title={formatText('raObjectiveTracking-projectionTitle')}
                    titleFontBigger={true}
                    goalReached={goalReached}
                    isGoalNotReached={outOfDate}
                    immPortfolio={immPortfolio}
                />
                {content}
            </section>
        );
    }

    getBreadcrumb() {
        return [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: BROKER_PG_URL,
            },
            {
                text: formatText('breadcrumb-breadcrumb_roboLanding'),
                url: MYPROFILE_BROKER_ROBO_URL,
            },
            {
                text: formatText('breadcrumb-breadcrumb_objectiveTracking'),
            },
        ];
    }

    getCancelMessage(isCancelInProgress) {
        let message;
        const informativeTitle = formatText(
            'raObjectiveTracking-raObjectiveTracking_cancelProgressTitle',
        );
        const informativeContent = (
            <FormattedText value="raObjectiveTracking-raObjectiveTracking_cancelProgressDescription" />
        );

        if (isCancelInProgress) {
            message = (
                <div className="row">
                    <div className="col-md-12 grid-view--fix-cell-separation">
                        <RAInformativeBox title={informativeTitle}>
                            {informativeContent}
                        </RAInformativeBox>
                    </div>
                </div>
            );
        }
        return message;
    }

    getChangeInProgressMessage(isChangeInProgress) {
        let message;
        const informativeTitle = formatText(
            'raPortfolioTracking-raPortfolioTracking_changeInProgressTitle',
        );

        if (isChangeInProgress) {
            message = (
                <div className="row">
                    <div className="col-md-12 grid-view--fix-cell-separation">
                        <RAInformativeBox title={informativeTitle}>
                            <FormattedText value="raPortfolioTracking-raPortfolioTracking_changeInProgressDescription" />
                        </RAInformativeBox>
                    </div>
                </div>
            );
        }
        return message;
    }

    handleOnProbabilityAnchorClick() {
        const headerHeight = 170;
        ScrollUtils.scrollWindowTo(
            ReactDOM.findDOMNode(this.raExpectedProfitabilityComponent),
            -headerHeight,
        );
    }

    handleOnUpdateCoverTitle(newName) {
        const {
            immPortfoliosNameHistory,
            immObjectiveDetailsReducer,
            match: {
                params: { portfolioId },
            },
        } = this.props;

        const namesHistory = immPortfoliosNameHistory.get('namesHistory');
        const nameExists = namesHistory.some(
            name => name.toLowerCase() === newName.toLowerCase(),
        );
        if (!nameExists) {
            // In this case the name not exist so is valid to update portfolio name
            const originalName = immObjectiveDetailsReducer.getIn([
                'name',
                'value',
            ]);
            const namePosition = namesHistory.findIndex(
                name => name.toLowerCase() === originalName.toLowerCase(),
            );
            this.props.updateObjectiveName(
                portfolioId,
                newName,
                null,
                namePosition,
            );
        } else {
            this.props.setHeaderTitleError();
        }
        recordLink(
            PROC_RA_OBJECTIVE_TRACKING_INTERACTION,
            PROC_RA_MODIFY_WALLET_NAME,
        );
    }

    handlePartialRefundModalToggle() {
        this.setState({
            isPartialRefundModalOpen: !this.state.isPartialRefundModalOpen,
        });
    }

    handleFeatureModal(link, type) {
        const { history, immRAFeatureFlag } = this.props;
        if (!immRAFeatureFlag.get(type)) {
            this.props.featureModalToggle();
        } else {
            history.push(link);
        }
    }

    getMoreOptions(immPortfolio) {
        const {
            immRAFeatureFlag,
            immFlagBasedFeatures,
            immCheckStatus,
        } = this.props;
        const maxTypeOfProduct = immPortfolio.getIn([
            'product',
            'maxTypeOfProduct',
        ]);
        const reimbursementLink = `${RA_REIMBURSEMENT_URL}/${this.props.match.params.portfolioId}`;
        const changeProductLink = `${RA_MODIFY_PLAN_URL}/${this.props.match.params.portfolioId}`;
        const cancelServiceLink = `${RA_CANCEL_PLAN_URL}/${this.props.match.params.portfolioId}`;
        const manageContributionsLink = `${RA_MANAGEMENT_CONTRIBUTION_URL}/${this.props.match.params.portfolioId}`;
        const ordersAndMovementsLink = `${RA_LAST_MOVEMENTS_URL}/${OBJECTIVE_TRACK_URL_PARA}/${this.props.match.params.portfolioId}`;
        const accountDetailsLink = `${RA_ACCOUNT_DETAILS_URL}/${this.props.match.params.portfolioId}/objective`;
        const dissociateObjectiveLink = `${RA_DISSOCIATE_OBJECTIVE_URL}/${this.props.match.params.portfolioId}`;
        const goalDate = immPortfolio.getIn(['goalInformation', 'goalDate']);
        const onDate = moment(goalDate).isSameOrBefore(moment(), 'day');
        const balance = immPortfolio.getIn(['keyFigures', 'valuation']);
        const isPartialReimbursementPossible =
            balance >= MINIMUM_STRATEGY_BALANCE_REIMBURSEMENT;

        return [
            {
                handleClick: () => {
                    recordLink(
                        PROC_RA_OBJECTIVE_TRACKING_INTERACTION,
                        PROC_RA_OPTIONS_MENU,
                        PROC_RA_OBJECTIVE_TRACKING_MANAGE_CONTRIBUTIONS,
                    );
                },
                link: manageContributionsLink,
                text: formatText(
                    'raGlobal-raGlobal_moreOptionsManagementContribution',
                ),
                visible:
                    immPortfolio &&
                    !!immPortfolio.get('recurringTransfers') &&
                    !onDate,
            },
            {
                handleClick: () => {
                    recordLink(
                        PROC_RA_OBJECTIVE_TRACKING_INTERACTION,
                        PROC_RA_OPTIONS_MENU,
                        PROC_RA_OBJECTIVE_TRACKING_PARTIAL_REFUND,
                    );
                    if (
                        immRAFeatureFlag.get('refund') &&
                        isPartialReimbursementPossible
                    ) {
                        this.handleFeatureModal(reimbursementLink, 'refund');
                    } else if (!immRAFeatureFlag.get('refund')) {
                        this.handleFeatureModal(reimbursementLink, 'refund');
                    } else if (!isPartialReimbursementPossible) {
                        this.handlePartialRefundModalToggle();
                    }
                },
                text: formatText('broker-globalPositionRAPopOverRefundRequest'),
                visible: !onDate,
            },
            {
                handleClick: () => {
                    recordLink(
                        PROC_RA_OBJECTIVE_TRACKING_INTERACTION,
                        PROC_RA_OPTIONS_MENU,
                        PROC_RA_TRACKING_ORDERS_MOVEMENTS,
                    );
                },
                link: ordersAndMovementsLink,
                text: formatText('broker-globalPositionRAPopOverMovements'),
                visible: true,
            },
            {
                handleClick: () => {
                    recordLink(
                        PROC_RA_OBJECTIVE_TRACKING_INTERACTION,
                        PROC_RA_OPTIONS_MENU,
                        PROC_RA_OBJECTIVE_TRACKING_MODIFY_STRATEGY,
                    );
                    if (
                        maxTypeOfProduct === SUITABILITY_TEST_HIGH_CONSERVATIVE
                    ) {
                        this.handleModifyModalClick();
                    } else if (
                        isTestValid(immCheckStatus) ||
                        !immFlagBasedFeatures.get(MODIFY_SUITABILITY_TEST)
                    ) {
                        this.handleFeatureModal(
                            changeProductLink,
                            'changeProduct',
                        );
                    } else {
                        this.setState({ showModalTestExpired: true });
                    }
                },
                text: formatText(
                    'broker-globalPositionRAPopOverModifyStrategy',
                ),
                visible: !onDate,
            },
            {
                handleClick: () => {
                    recordLink(
                        PROC_RA_OBJECTIVE_TRACKING_INTERACTION,
                        PROC_RA_OPTIONS_MENU,
                        PROC_RA_TRACKING_SUITABILITY_TEST,
                    );
                },
                link: SUITABILITY_TEST_STATUS_URL,
                text: formatText(
                    'broker-globalPositionRAPopOverSuitabilityTest',
                ),
                visible: !onDate,
            },
            {
                handleClick: () => {
                    recordLink(
                        PROC_RA_OBJECTIVE_TRACKING_INTERACTION,
                        PROC_RA_OPTIONS_MENU,
                        PROC_RA_OBJECTIVE_TRACKING_TOTAL_REFUND,
                    );
                    this.handleFeatureModal(cancelServiceLink, 'cancelService');
                },
                text: formatText('broker-globalPositionRAPopOverCancelService'),
                visible: true,
            },
            {
                handleClick: () => {
                    recordLink(
                        PROC_RA_OBJECTIVE_TRACKING_INTERACTION,
                        PROC_RA_OPTIONS_MENU,
                        PROC_RA_OBJECTIVE_TRACKING_ACCOUNT_DETAILS,
                    );
                },
                link: accountDetailsLink,
                text: formatText('broker-getAccountDetails'),
                visible: !onDate,
            },
            {
                handleClick: () => {
                    recordLink(
                        PROC_RA_OBJECTIVE_TRACKING_INTERACTION,
                        PROC_RA_OPTIONS_MENU,
                        PROC_RA_OBJECTIVE_TRACKING_DISSOCIATE_OBJECTIVE,
                    );
                },
                link: dissociateObjectiveLink,
                text: formatText('broker-dissociateObjectiveLink'),
                visible: true,
            },
        ];
    }

    buildFeatureModal() {
        const { immRAFeatureFlag, featureModalToggle } = this.props;
        return (
            <RAFeatureFlagModal
                immRAFeatureFlag={immRAFeatureFlag}
                featureModalToggle={featureModalToggle}
            />
        );
    }

    buildModifyWarningModal() {
        const { immSuitabilityTest } = this.props;
        const investProfile = immSuitabilityTest.getIn([
            'results',
            0,
            'clientRiskProfileTitle',
        ]);

        return (
            <RAModifyPlanWarningModal
                isOpen={this.state.isModifyModalOpen}
                onRequestClose={this.handleModifyModalClose}
                investProfile={investProfile}
            />
        );
    }

    buildPartialReimbursementModal() {
        const { isPartialRefundModalOpen } = this.state;
        const modalTitle = (
            <FormattedText
                className="ra-objective-tracking-view__reimbursement-modal-title"
                value="raReimbursementModal-raReimbursementModal_title"
            />
        );
        const modalContent = (
            <FormattedText value="raReimbursementModal-raReimbursementModal_contentText" />
        );
        return (
            <OKModal
                content={modalContent}
                footerType="action"
                isOpen={isPartialRefundModalOpen}
                onPrimaryButtonClick={this.handlePartialRefundModalToggle}
                primaryButtonText="raReimbursementModal-raReimbursementModal_CTA"
                onCloseCallback={this.handlePartialRefundModalToggle}
                shouldCloseOnOverlayClick={false}
                title={modalTitle}
                titleAlignment="center"
            />
        );
    }

    handleAdditionalContribution() {
        const {
            history,
            immRAFeatureFlag,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        recordLink(
            PROC_RA_OBJECTIVE_TRACKING_INTERACTION,
            PROC_RA_NEW_CONTRIBUTION,
        );
        if (
            !immRAFeatureFlag.get('recurringContribution') &&
            !immRAFeatureFlag.get('additionalContribution')
        ) {
            this.props.featureModalToggle();
        } else {
            const additionalContributionLink = `${RA_ADDITIONAL_CONTRIBUTION_URL}/${portfolioId}`;
            history.push(additionalContributionLink);
        }
    }

    buildGoalNotification(immPortfolio) {
        const immGoals = Immutable.List.of(immPortfolio);
        return (
            <RAGoalNotification
                immGoals={immGoals}
                onClose={this.handleGoalNotificationClose}
                onModifyAmountClick={this.handleGoalNotificationAmountClick}
                showGoalLink={false}
            />
        );
    }

    handleGoalNotificationCloseForContactCenter() {
        this.setState({
            showGoalNotificationForContactCenter: false,
        });
    }

    handleModifyGoalAmountClick(id) {
        const url = `${GOAL_TRACKING_URL}/${id}`;
        this.props.setFromPGNotification();
        this.props.history.push(url);
    }

    buildNotificationForCC() {
        const {
            immProfile,
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        const goalData = immGlobalPosition
            .get('portfolios')
            .filter(data => data.get('id') === portfolioId);
        const userName = immProfile.get('fullname');
        return (
            <RAObjectiveInfomationNotification
                goalData={goalData}
                userName={userName}
                onClose={this.handleGoalNotificationCloseForContactCenter}
                onModifyAmountClick={this.handleModifyGoalAmountClick}
                showGoalLink={false}
            />
        );
    }

    handleFundNotificationClose() {
        this.setState({
            showFundTrasnferNotification: false,
        });
    }

    buildFundTransferNotification() {
        const {
            immGlobalPosition,
            immProfile,
            match: {
                params: { portfolioId },
            },
            setSinglePortfolioNotificationClosed,
            setSinglePortfolioNotificationDisabled,
        } = this.props;
        const portfolio = immGlobalPosition.getIn(['portfolios', portfolioId]);
        const hiringMethod = portfolio.get('hiringMethod');
        let currentStep = 0;
        const fundsTransferStepsWidgetClosed = portfolio.getIn([
            'state',
            'fundsTransferStepsWidgetClosed',
        ]);
        if (
            !fundsTransferStepsWidgetClosed &&
            hiringMethod === RA_PORTFOLIO_FUND_HIRING_METHOD
        ) {
            const funded = portfolio.getIn(['state', 'funded']);
            const fullyFunded = portfolio.getIn(['state', 'fullyFunded']);
            const objectiveOrderAndMovementURL = `${RA_LAST_MOVEMENTS_URL}/${OBJECTIVE_TRACK_URL_PARA}/${portfolioId}`;
            const userName = immProfile.get('fullname');
            const isNotificationClosed = portfolio.get('isNotificationClosed');
            if (!funded && !fullyFunded) {
                currentStep = RA_FUND_TRANSFER_STEP1;
            } else if (funded && !fullyFunded) {
                currentStep = RA_FUND_TRANSFER_STEP2;
            } else if (funded && fullyFunded) {
                currentStep = RA_FUND_TRANSFER_STEP3;
            }
            const content = !isNotificationClosed ? (
                <div className="row">
                    <div className="col-xs-12 col-md-12 ra-objective-tracking-view__fund-notification">
                        <RAFundTransferNotification
                            onClose={this.handleFundNotificationClose}
                            currentStep={currentStep}
                            forSinglePortfolio={true}
                            movementLink={objectiveOrderAndMovementURL}
                            userName={userName}
                            closeNotification={
                                setSinglePortfolioNotificationClosed
                            }
                            disableNotification={
                                setSinglePortfolioNotificationDisabled
                            }
                            portfolioId={portfolioId}
                        />
                    </div>
                </div>
            ) : null;
            return content;
        }
    }

    handleModalTestExpiredLink() {
        const {
            history,
            setOrigin,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        setOrigin(RA_SUITABILITY_TEST_MODIFYGOAL_OPERATION, portfolioId);
        history.push(RA_SUITABILITY_TEST_URL);
    }

    handleCloseModalTestExpired() {
        this.setState({ showModalTestExpired: false });
    }

    buildTestExpiredModal() {
        const { showModalTestExpired } = this.state;
        const content = (
            <FormattedText value="modalTestExpired-modalTestExpired_contentDescription" />
        );
        const title = (
            <FormattedText value="modalTestExpired-modalTestExpired_titleDescription" />
        );
        const contentFooter = (
            <div className="ra-objective-tracking-view__modal">
                <OKButton onClick={this.handleModalTestExpiredLink}>
                    <FormattedText value="modalTestExpired-modalTestExpired_buttonDescription" />
                </OKButton>
            </div>
        );
        return (
            <OKModal
                isOpen={showModalTestExpired}
                shouldCloseOnOverlayClick={false}
                description={content}
                descriptionAlignment="center"
                title={title}
                titleAlignment="center"
                contentFooter={contentFooter}
                onCloseCallback={this.handleCloseModalTestExpired}
            />
        );
    }

    handleGoBackButtonClick() {
        recordLink(PROC_RA_OBJECTIVE_TRACKING_INTERACTION, PROC_RA_GO_BACK);
    }

    onCalculateLinkClick() {
        recordLink(
            PROC_RA_OBJECTIVE_TRACKING_INTERACTION,
            PROC_RA_HELP_PATRIMONY_CALCULATION,
        );
    }

    handleContributionsManageClick() {
        recordLink(
            PROC_RA_OBJECTIVE_TRACKING_INTERACTION,
            PROC_RA_MANAGE_CONTRIBUTIONS,
        );
    }

    handleMoneyMarketLinkClick() {
        recordLink(
            PROC_RA_OBJECTIVE_TRACKING_INTERACTION,
            PROC_RA_OBJECTIVE_TRACKING_MONEY_MARKET_HELP,
        );
    }

    handleDistributionLinkClick() {
        recordLink(
            PROC_RA_OBJECTIVE_TRACKING_INTERACTION,
            PROC_RA_OBJECTIVE_TRACKING_DISTRIBUTION,
        );
    }

    handleGoToOrdersAndMovements() {
        recordLink(
            PROC_RA_OBJECTIVE_TRACKING_INTERACTION,
            PROC_RA_GO_TO_ORDERS_AND_MOVEMENTS,
        );
    }

    handleReturnTestClick() {
        recordLink(
            PROC_RA_GLOBAL_POSITION_INTERACTION,
            PROC_RA_GLOBAL_POSITION_RETURN_TEST,
        );
        this.props.history.push(RA_SUITABILITY_TEST_URL);
    }

    handleCloseUnsuitableTest() {
        this.setState({
            showUnsuitableTestCancelation: false,
        });
    }

    buildUnsuitableTestCancelationBox() {
        const { showUnsuitableTestCancelation } = this.state;
        const link = (
            <OKLink onClick={this.handleReturnTestClick}>
                <FormattedText value="raGlobalPosition-raGlobalPosition_unsuitableTestNotificationLinkText" />
            </OKLink>
        );
        return (
            <div className="ra-portfolio-tracking-view__notifications-box">
                <OKMessage
                    type="informative"
                    modifier="dark-bg"
                    closeButton
                    visible={showUnsuitableTestCancelation}
                    onCloseButtonClick={this.handleCloseUnsuitableTest}
                >
                    <FormattedTextWithComponents
                        value="raGlobalPosition-raGlobalPosition_unsuitableTestNotificationContent"
                        injectedComponents={[link]}
                    />
                </OKMessage>
            </div>
        );
    }

    render() {
        const {
            fetchAlerts,
            immCheckStatus,
            immFlagBasedFeatures,
            immRAAlerts,
            immObjectiveDetailsReducer,
            immGlobalPosition,
            immAccountDetails,
            match: {
                params: { portfolioId },
            },
        } = this.props;

        const isAllowed = immFlagBasedFeatures.get(MODIFY_SUITABILITY_TEST);
        const isExpiredTest = isTestExpired(immCheckStatus);
        const showTestExpiredAlert = isAllowed && isExpiredTest;
        const testExpiredModal = showTestExpiredAlert
            ? this.buildTestExpiredModal()
            : null;
        const immPortfolio = immGlobalPosition.getIn(
            ['portfolios', portfolioId],
            Immutable.Map(),
        );
        const goalProgress = immPortfolio.getIn([
            'goalInformation',
            'goalProgress',
        ]);
        const mappingBreadcrumb = this.getBreadcrumb();
        const portfolioEvolutionElement = immPortfolio
            ? this.getPortfolioEvolution(immPortfolio)
            : null;
        const expectedProfitabilityElement = this.getExpectedProfitability();

        const immObjectiveKeyFigures = immObjectiveDetailsReducer.get(
            'keyFigures',
        );
        const actualAmount = immObjectiveKeyFigures.get('valuation');
        const totalDeposits = immObjectiveKeyFigures.get('deposits') || 0;
        const initialInvestmentAmount =
            immObjectiveKeyFigures.get('initialInvestment') || 0;
        const contributionAmount = totalDeposits - initialInvestmentAmount;
        const profitabilityAmount = immObjectiveKeyFigures.get('netReturn');
        const profitabilityWeighted = immObjectiveKeyFigures.get(
            'timeWeightedReturn',
        );
        const refundAmount = immObjectiveKeyFigures.get('withdrawals');

        const periodicTransferAmount = immObjectiveDetailsReducer.getIn([
            'periodicTransfer',
            'amount',
        ]);
        const periodicTransferDate = immObjectiveDetailsReducer.getIn([
            'periodicTransfer',
            'nextDate',
        ]);
        const periodicityTransferCode = immObjectiveDetailsReducer.getIn([
            'periodicTransfer',
            'periodicity',
        ]);

        const headingTitle =
            immObjectiveDetailsReducer.getIn(['name', 'value']) || LOADING;
        const errorTitle = immObjectiveDetailsReducer.getIn(['name', 'error']);
        const errorTitleMessage = formatText(
            'raManagementPlan-raManagementPlan_customNameError',
        );
        const isAccordionDistributionTableLoading = immObjectiveDetailsReducer.get(
            'isFetchingDetail',
        );

        const managementContributionLink = `${RA_MANAGEMENT_CONTRIBUTION_URL}/${portfolioId}`;
        const moreOptionsArray = immPortfolio
            ? this.getMoreOptions(immPortfolio)
            : [];
        const isCancelInProgress = immObjectiveDetailsReducer.getIn([
            'state',
            'cancelled',
        ]);
        const cancelInProgressMessage = this.getCancelMessage(
            isCancelInProgress,
        );
        const isProductChangeInProgress = immObjectiveDetailsReducer.getIn([
            'state',
            'productChangeInProgress',
        ]); //strategyChange
        const changeInProgressMessage = this.getChangeInProgressMessage(
            isProductChangeInProgress,
        );
        const amountVal = immObjectiveDetailsReducer.getIn([
            'editAmountModal',
            'objectiveAmount',
        ]);
        const partialReimbursementModal = this.buildPartialReimbursementModal();
        const featureModal = this.buildFeatureModal();
        const goalDistributionLink = `${GOAL_DISTRIBUTION_URL}/${portfolioId}`;
        const modifyWarningModal = this.buildModifyWarningModal();
        const objectiveDetailModalLinkText = formatText(
            'raCustomModel-modelTitleForObjectivo',
        );
        let rightContent = (
            <RARoboMoreOptionsButton
                moreOptions={moreOptionsArray}
                buttonDisabled={isCancelInProgress}
                onGoBackButtonClick={this.handleGoBackButtonClick}
            />
        );

        const goalNotificationSection =
            !__CONTACT_CENTER__ && this.state.showGoalNotification
                ? this.buildGoalNotification(immPortfolio)
                : null;
        const goalNotificationSectionForCC = this.state
            .showGoalNotificationForContactCenter
            ? this.buildNotificationForCC()
            : null;

        const goalReached =
            immPortfolio.getIn(['goalInformation', 'goalProgress']) >= 1;
        const goalEndDate = immObjectiveDetailsReducer.get('objectiveEndDate');
        const goalDateExpired = moment(goalEndDate).isSameOrBefore(
            moment(),
            'day',
        );
        const isGoalNotReached = !goalReached && goalDateExpired;
        const isGoalReachedOnDate = goalReached && goalDateExpired;
        const fundTransferNotification =
            this.state.showFundTrasnferNotification &&
            this.buildFundTransferNotification();

        let cgdNumber, subtitle;
        if (immAccountDetails) {
            cgdNumber = immAccountDetails.get('cgdNumber');
            if (cgdNumber) {
                subtitle = <RACgdNumber cgdNumberVal={cgdNumber} />;
            }
        }
        let movementsLink;
        if (!isCancelInProgress) {
            const url = `${RA_LAST_MOVEMENTS_URL}/${OBJECTIVE_TRACK_URL_PARA}/${portfolioId}`;
            movementsLink = (
                <div className="ra-objective-tracking-view__movement-link">
                    <OKLink
                        to={url}
                        modifier="complementary"
                        onClick={this.handleGoToOrdersAndMovements}
                    >
                        <FormattedText value="raGlobalPosition-raGlobalPosition_goToOrdersAndMovements" />
                    </OKLink>
                </div>
            );
        }

        const unsuitableTestBox =
            immFlagBasedFeatures.get('sign_suitability_test_not_suitable') &&
            immCheckStatus.get('nonSuitableTest')
                ? this.buildUnsuitableTestCancelationBox()
                : null;

        return (
            <div className="ra-objective-tracking-view grid-view">
                <div className="container-fluid">
                    <div className="row">
                        <RACover
                            breadcrumb={mappingBreadcrumb}
                            section="goal"
                            goalType={immObjectiveDetailsReducer.get(
                                'goalType',
                            )}
                            showHelp={false}
                            title={headingTitle}
                            titleEditable={true}
                            onUpdateTitle={this.handleOnUpdateCoverTitle}
                            rightContent={rightContent}
                            fontSize={RA_COVER_FONT}
                            subtitle={subtitle}
                            errorTitle={errorTitle}
                            errorTitleMessage={errorTitleMessage}
                        />
                    </div>
                </div>
                <div className="row ra-objective-tracking-view__container">
                    <div className="grid-view__body">
                        {unsuitableTestBox}
                        <div className="container-fluid">
                            <ContactCenterRender>
                                {goalNotificationSectionForCC}
                            </ContactCenterRender>
                            {cancelInProgressMessage}
                            <RATestExpirationDisclaimer />
                            {changeInProgressMessage}
                            {testExpiredModal}
                            {featureModal}
                            {partialReimbursementModal}
                            {modifyWarningModal}
                            {goalNotificationSection}
                            {fundTransferNotification}
                            <div className="row">
                                <div className="col-md-12 grid-view--fix-cell-separation">
                                    <RAObjectiveDetails
                                        isFetching={immObjectiveDetailsReducer.get(
                                            'isFetchingDetail',
                                        )}
                                        goalType={immObjectiveDetailsReducer.get(
                                            'goalType',
                                        )}
                                        goalProgress={goalProgress}
                                        objectiveAmount={amountVal}
                                        objectiveEndDate={goalEndDate}
                                        onProbabilityAnchorClick={
                                            this.handleOnProbabilityAnchorClick
                                        }
                                        probability={immObjectiveDetailsReducer.get(
                                            'probability',
                                        )}
                                        actualAmount={actualAmount}
                                        profitabilityAmount={
                                            profitabilityAmount
                                        }
                                        profitabilityWeighted={
                                            profitabilityWeighted
                                        }
                                        initialInvestmentAmount={
                                            initialInvestmentAmount
                                        }
                                        contributionAmount={contributionAmount}
                                        refundAmount={refundAmount}
                                        immEditAmountModal={immObjectiveDetailsReducer.get(
                                            'editAmountModal',
                                        )}
                                        showEditAmountModal={
                                            this.props
                                                .showEditObjectiveAmountModal
                                        }
                                        hideEditAmountModal={
                                            this.props
                                                .hideEditObjectiveAmountModal
                                        }
                                        portfolioId={
                                            this.props.match.params.portfolioId
                                        }
                                        updateObjectiveName={
                                            this.props.updateObjectiveName
                                        }
                                        resetAmountValue={
                                            this.props.resetAmountValue
                                        }
                                        modalLinkText={
                                            objectiveDetailModalLinkText
                                        }
                                        calculateLinkClick={
                                            this.onCalculateLinkClick
                                        }
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12 col-md-8">
                                    <div className="row">
                                        <div className="col-md-12 grid-view--fix-cell-separation">
                                            {portfolioEvolutionElement}
                                        </div>
                                        <div className="col-md-12 grid-view--fix-cell-separation">
                                            {expectedProfitabilityElement}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-4">
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation">
                                            <RAContributions
                                                isGoalNotReached={
                                                    isGoalNotReached
                                                }
                                                isLoading={immObjectiveDetailsReducer.get(
                                                    'isFetchingDetail',
                                                )}
                                                managementLink={
                                                    managementContributionLink
                                                }
                                                periodicTransferAmount={
                                                    periodicTransferAmount
                                                }
                                                periodicTransferDate={
                                                    periodicTransferDate
                                                }
                                                periodicityTransferCode={
                                                    periodicityTransferCode
                                                }
                                                portfolioId={portfolioId}
                                                isCancelInProgress={
                                                    isCancelInProgress
                                                }
                                                additionalContributionClick={
                                                    this
                                                        .handleAdditionalContribution
                                                }
                                                isGoalReachedOnDate={
                                                    isGoalReachedOnDate
                                                }
                                                contributionsManageLinkClick={
                                                    this
                                                        .handleContributionsManageClick
                                                }
                                            />
                                        </div>
                                        <div className="col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation">
                                            <RAAlertsWidget
                                                fetchAlerts={fetchAlerts}
                                                immAlertsData={immRAAlerts}
                                            />
                                        </div>
                                        <div className="col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation">
                                            <RADistributionWidget
                                                buildWidget={false}
                                                distributionTitle={formatText(
                                                    'raObjectiveTracking-distributionTitle',
                                                )}
                                                enableAssetsTabsSidebarDesign={
                                                    true
                                                }
                                                hasRoboHired={true}
                                                immRoboAdvisor={
                                                    immObjectiveDetailsReducer
                                                }
                                                pieHeight={150}
                                                pieWeight={26}
                                                pieWidth={150}
                                                showCalulationInfoLink={false}
                                                handleMoneyMarketLinkClick={
                                                    this
                                                        .handleMoneyMarketLinkClick
                                                }
                                            />
                                            <div className="ra-objective-tracking-view__footer-content">
                                                <OKLink
                                                    to={goalDistributionLink}
                                                    inverse={true}
                                                    extraClass="ra-objective-tracking-view__distribution-link"
                                                    modifier="complementary"
                                                    // eslint-disable-next-line react/jsx-handler-names
                                                    onClick={
                                                        this
                                                            .handleDistributionLinkClick
                                                    }
                                                >
                                                    <FormattedText value="raObjectiveTracking-distributionLink" />
                                                </OKLink>
                                                <ContactCenterRender>
                                                    <OKModal
                                                        extraClass="ra-objective-tracking-view__distribution-detail-modal"
                                                        isOpen={
                                                            this.state
                                                                .moneyMarketModalIsOpen
                                                        }
                                                        onCloseCallback={
                                                            // eslint-disable-line
                                                            this
                                                                .handleModalClose
                                                        }
                                                        shouldCloseOnOverlayClick={
                                                            true
                                                        }
                                                    >
                                                        <div className="ra-objective-tracking-view__distribution-model-content">
                                                            <h4 className="ra-objective-tracking-view__distribution-model-title">
                                                                <FormattedText value="raManagementPlanView-distributionDetailsTitle" />
                                                            </h4>
                                                            <RAAccordionDistributionTable
                                                                immKeyFigures={immObjectiveDetailsReducer.get(
                                                                    'keyFigures',
                                                                )}
                                                                immAssetAllocations={immObjectiveDetailsReducer.get(
                                                                    'assetAllocation',
                                                                )}
                                                                isFetching={
                                                                    isAccordionDistributionTableLoading
                                                                }
                                                                scroll={true}
                                                                showRentabilityPercentage={
                                                                    true
                                                                }
                                                            />
                                                        </div>
                                                    </OKModal>
                                                </ContactCenterRender>
                                            </div>
                                            {movementsLink}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

RAObjectiveTrackingView.propTypes = {
    fetchMyInvestments: PropTypes.func.isRequired,
    readPortfolioFromGlobalPosition: PropTypes.func.isRequired,
    hideEditObjectiveAmountModal: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immEvolutionChartData: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immObjectiveDetailsReducer: PropTypes.object,
    immPortfoliosNameHistory: PropTypes.object.isRequired,
    requestPortfolioEvolutionChart: PropTypes.func,
    requestProjectionChart: PropTypes.func.isRequired,
    immProjectionChartData: PropTypes.object.isRequired,
    immRAAlerts: PropTypes.object.isRequired,
    immCheckStatus: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    immSuitabilityTest: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    fetchAlerts: PropTypes.func.isRequired,
    setDaysDiffrence: PropTypes.func.isRequired,
    showEditObjectiveAmountModal: PropTypes.func.isRequired,
    setHeaderTitleError: PropTypes.func.isRequired,
    setObjectiveAmount: PropTypes.func.isRequired,
    updateObjectiveName: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    resetAmountValue: PropTypes.func.isRequired,
    immRAFeatureFlag: PropTypes.object.isRequired,
    featureModalToggle: PropTypes.func.isRequired,
    fetchFeatureFlag: PropTypes.func.isRequired,
    getCGDAccountNumberVal: PropTypes.func.isRequired,
    getDisplayNames: PropTypes.func.isRequired,
    immAccountDetails: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    removeFilter: PropTypes.func.isRequired,
    setFromPGNotification: PropTypes.func.isRequired,
    setOrigin: PropTypes.func.isRequired,
    setOriginRedirection: PropTypes.func.isRequired,
    setSinglePortfolioNotificationClosed: PropTypes.func.isRequired,
    setSinglePortfolioNotificationDisabled: PropTypes.func.isRequired,
};

module.exports = connect(
    state => ({
        immAccounts: state.accounts,
        immAccountDetails: state.raAccountDetails,
        immBrokerMyInvestments: state.brokerMyInvestments,
        immCheckStatus: state.raCheckStatus,
        immEvolutionChartData: state.raEvolutionChartOjectiveTrackingReducer,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immObjectiveDetailsReducer: state.raObjectiveDetailsReducer,
        immPortfoliosNameHistory: state.raPortfoliosNameHistory,
        immProfile: state.profile,
        immProjectionChartData: state.raProjectionChartOjectiveTrackingReducer,
        immRAAlerts: state.raAlertsReducer,
        immGlobalPosition: state.raGlobalPosition,
        immRAFeatureFlag: state.raFeatureFlag,
        immSuitabilityTest: state.raSuitabilityTest,
    }),
    {
        fetchMyInvestments: brokerMyInvestments.fetchMyInvestments,
        readPortfolioFromGlobalPosition:
            raObjectiveDetailsActions.readPortfolioFromGlobalPosition,
        hideEditObjectiveAmountModal:
            raObjectiveDetailsActions.hideEditAmountModal,
        fetchAlerts: RAAlertsActions.fetchAlerts,
        getDisplayNames: raPortfoliosNameHistoryActions.getDisplayNames,
        requestPortfolioEvolutionChart:
            raEvolutionChartOjectiveTracking.requestPortfolioEvolutionChart,
        requestProjectionChart:
            raProjectionChartOjectiveTracking.requestProjectionChart,
        setDaysDiffrence: raProjectionChartOjectiveTracking.setDaysDiffrence,
        showEditObjectiveAmountModal:
            raObjectiveDetailsActions.showEditAmountModal,
        updateObjectiveName: raObjectiveDetailsActions.updateObjectiveName,
        setObjectiveAmount: raObjectiveDetailsActions.setObjectiveAmount,
        reset: raObjectiveDetailsActions.reset,
        resetAmountValue: raObjectiveDetailsActions.resetAmountValue,
        setHeaderTitleError: raObjectiveDetailsActions.setHeaderTitleError,
        featureModalToggle: RAFeatureFlagActions.featureModalToggle,
        fetchFeatureFlag: RAFeatureFlagActions.fetchFeatureFlag,
        getCGDAccountNumberVal: raAccountDetailsActions.getCGDAccountNumber,
        removeFilter: raLastMovementActions.removeFilter,
        setFromPGNotification: raObjectiveDetailsActions.setFromPGNotification,
        setOrigin: suitabilityActions.setOrigin,
        setOriginRedirection: raGlobalPosition.setOriginRedirection,
        setSinglePortfolioNotificationClosed:
            raGlobalPosition.setSinglePortfolioNotificationClosed,
        setSinglePortfolioNotificationDisabled:
            raGlobalPosition.setSinglePortfolioNotificationDisabled,
    },
)(withRouter(RAObjectiveTrackingView));
